import { IssueTypeDto } from '@issuemanager/api-client';
import { useLocalizedIssueTypes } from '@issuemanager/client/features/issues';
import { IssueType } from '@issuemanager/constants';
import { useEventCallback } from '@mui/material';
import { FakeDropdownBox } from '../../../filters';
import { IssueTypeMultipleSelector } from '../../../inputs';
import { useDataGridContext } from '../../data-grid-context';
import type { ExtendedGridColumnHeaderProps } from '../../types';
import { ContainerPopper } from './container-popper';

export function DataGridIssueTypeFilter(params: ExtendedGridColumnHeaderProps) {
  const context = useDataGridContext();
  const localizedIssueTypes = useLocalizedIssueTypes();
  const value: IssueTypeDto[] = context.filterModel[params.field] ?? [];

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
      issueSubtype: [],
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0
            ? value
                .map((c) => localizedIssueTypes[c.name as IssueType] ?? c.name)
                .join(', ')
            : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <IssueTypeMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
